/**
 * Main JavaScript entry point for Vite build
 * This file imports all theme scripts
 */

// Import the main custom scripts
import './custom-scripts.js';

// You can add additional imports here as needed
// import './custom-script.js'; // Uncomment if needed

console.log('Oaku theme scripts loaded via Vite!');
